module.exports = "/assets/data/10023f9115b285ba70a1fee72c5351c4-SK9.data.json";